import { useCallback, useMemo } from 'react'
import noop from 'lib/function/noop'
import Image from 'components/Common/Image'
import { escapeRegex } from 'lib/string/regexUtils'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'
import styled from 'styled-components'
import clsx from 'clsx'
import { trackClientEvent } from 'analytics/analytics'

const CruiseLineLogo = styled(Image)`
  &.disabled {
    opacity: 0.5;
  }
`

interface Props {
  cruiseLine: App.CruiseLineFacetV2Item
  isSelected?: boolean
  isDisabled?: boolean
  searchTerm?: string
  onClick?: (cruiseLine: string) => void
}

function CruiseLinesSearchListItem(props: Props) {
  const { cruiseLine, searchTerm, isSelected, isDisabled, onClick = noop } = props
  const handleSelectItem = useCallback(() => {
    trackClientEvent({
      subject: 'filter_item_selected',
      action: 'selected',
      category: 'cruise_line_filter',
      type: 'interaction',
    })
    onClick(cruiseLine.slug)
  }, [cruiseLine, onClick])

  const label = useMemo(() => {
    if (!searchTerm) {
      return cruiseLine.label
    }

    const search = new RegExp(`(${escapeRegex(searchTerm)})`, 'ig')
    const bits = cruiseLine.label.split(search)

    return <>
      {bits.map((textBit, index) => textBit.toLowerCase() === searchTerm.toLowerCase() ? <b key={index}>{textBit}</b> : textBit, '')}
    </>
  }, [searchTerm, cruiseLine.label])

  return <ClickableListItem
    onClick={handleSelectItem}
    title={label}
    disabled={isDisabled}
    startIcon={<CruiseLineLogo
      id={cruiseLine.smallImageId ?? cruiseLine.imageId}
      alt={cruiseLine.label}
      width={48}
      height={32}
      className={clsx({ disabled: isDisabled })}
    />}
    endIcon={<CheckboxButton size="large" checked={isSelected} disabled={isDisabled} />}
  />
}

export default CruiseLinesSearchListItem
